import { render, staticRenderFns } from "./InactivityWatcher.vue?vue&type=template&id=52f227e7"
import script from "./InactivityWatcher.vue?vue&type=script&lang=js"
export * from "./InactivityWatcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports